import { render } from "./smpParticipantsTable.vue?vue&type=template&id=507b35f9&scoped=true"
import script from "./smpParticipantsTable.vue?vue&type=script&lang=js"
export * from "./smpParticipantsTable.vue?vue&type=script&lang=js"

import "./smpParticipantsTable.vue?vue&type=style&index=0&id=507b35f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507b35f9"]])

export default __exports__